/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrganizationRequest
 */
export interface CreateOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    photoURL?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    ownerId: string;
}

/**
 * Check if a given object implements the CreateOrganizationRequest interface.
 */
export function instanceOfCreateOrganizationRequest(value: object): value is CreateOrganizationRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('ownerId' in value) || value['ownerId'] === undefined) return false;
    return true;
}

export function CreateOrganizationRequestFromJSON(json: any): CreateOrganizationRequest {
    return CreateOrganizationRequestFromJSONTyped(json, false);
}

export function CreateOrganizationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'currency': json['currency'],
        'address': json['address'] == null ? undefined : json['address'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
        'photoURL': json['photoURL'] == null ? undefined : json['photoURL'],
        'ownerId': json['ownerId'],
    };
}

export function CreateOrganizationRequestToJSON(json: any): CreateOrganizationRequest {
    return CreateOrganizationRequestToJSONTyped(json, false);
}

export function CreateOrganizationRequestToJSONTyped(value?: CreateOrganizationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'currency': value['currency'],
        'address': value['address'],
        'phone': value['phone'],
        'email': value['email'],
        'photoURL': value['photoURL'],
        'ownerId': value['ownerId'],
    };
}

